import React, {useState} from 'react';
import styles from './transfer-details-modal-content.module.scss';
import { Row, Col, Button, Spinner } from 'react-bootstrap';
import SuccessModalContent
  from "../../../../../securities/security-details/components/modal-content-success/modal-content-success";
import {
  TRANSFER_CONFIRM_ERROR,
  TRANSFER_CONFIRM_SUCCESS,
  TRANSFER_PENDING_PDTC_PROCESSING
} from "../../../../../../helpr/constants";
import ErrorModalContent
  from "../../../../../securities/security-details/components/modal-content-error/modal-content-error";
import {toCurrency} from "../../../../../../helpr/helper";
import editIcon from "../../../../../../assets/edit.svg";
import {DateInput, DropDown, TextInput} from "../../../../../../components/form/form";
import {useValidation} from "../../../../../../hooks/use-validation";
import checkIcon from "../../../../../../assets/orders-table-accept.svg";
import rejectIcon from "../../../../../../assets/orders-table-reject.svg";
import {getGraduatedTaxStatusTypes, getTaxStatusTypes, getToTypes} from "../../../../../../helpr/transferFormData";
import SecondaryMarketService from "../../../../../../services/secondary-market-service";
import {
  confirmTransferObj,
  confirmTransferValidator
} from "../../../../../../form-control/confirm-transfer-form/confirm-transfer-form-control";
import numToWords from "../../../../../../helpr/numToWords";

const TransferDetailsModalContent = ({context, onClose}) => {
  const SUCCESS_TITLE = "TRANSFER CONFIRMED";
  const ERROR_TITLE = "A PROBLEM OCCURRED";
  const [ loading, setLoading ] = useState(false);
  const [ page, setPage ] = useState(0);

  const secondaryMarketService = new SecondaryMarketService();
  const { selectedTransfer, setTransferList } = context;
  const [ transfer, setTransfer ] = useState(selectedTransfer.current);
  const [ toggleEditFields, setToggleEditFields ] = useState({
    transferDate: false,
    settlementDate: false,
    fromRegistryBpId: false,
    fromAccountNumber: false,
    toType: false,
    toDepositoryBpId: false,
    toDepositoryAccountNumber: false,
    toRegistryBpId: false,
    toRegistryAccountNo: false
  });
  const [checkboxState, setCheckboxState] = useState(false);

  //Setup validator and transfer instruction state
  const confirmTransferState = useValidation(
    confirmTransferValidator,
    confirmTransferObj(selectedTransfer.current),
    {border: '1px solid red'});
  const { validate, getTextFieldProps, getDropdownProps } = confirmTransferState;

  const confirm = async () => {
    setLoading(true)
    try {
      const { formState, isFormValid } = validate();
      if(isFormValid){
        await secondaryMarketService.confirmTransfer(transfer.transferId, formState);
        setTransferList(prev => {
          const updatedList = prev.map(p => {
            if(p.transferId === transfer.transferId){
              return {
                ...p,
                ...transfer,
                transferStatus: TRANSFER_PENDING_PDTC_PROCESSING
              }
            }
            return p
          });
          return updatedList;
        });
      }
      setPage(1)
    }catch(error){
      setPage(2)
    }finally{
      setLoading(false);
    }
  }

  const onConfirm = () => {
    setCheckboxState(!checkboxState);
  }

  const onConfirmEdit = key => {
    const { formState, isFormValid } = validate();
    console.log(formState, isFormValid);
    if(isFormValid){
      setToggleEditFields({
        ...toggleEditFields,
        [key]: !toggleEditFields[key]
      });
      setTransfer({
        ...transfer,
        [key]: formState[key]
      });
    }
  }

  const toggleEditableFields = key => {
    setToggleEditFields({
      ...toggleEditFields,
      [key]: !toggleEditFields[key]
    });
  }

  const renderEditableFields = (key, input) => {
    return toggleEditFields[key] ? (
      <div className={styles['edit-field']}>
        {input}
        <div onClick={() => onConfirmEdit(key)} className={styles['confirm-scale-down']}>
          <img alt="Confirm" src={checkIcon} />
        </div>
        <div onClick={() => toggleEditableFields(key)} className={styles['cancel-scale-down']}>
          <img alt="Cancel" src={rejectIcon}/>
        </div>
      </div>
    ) : (
      <div>
        {transfer[key]}
        {transfer.transferStatus === '1' || (transfer.transferStatus === '5' && transfer.rejectFields.map(f => f.key).includes(key))
          ? <img className={styles['edit']} onClick={()=>toggleEditableFields(key)} alt="Edit" src={editIcon} /> : ''}
      </div>
    )
  }

  const renderConfirmResult = () => {
    switch(page){
      case 1:
        return <SuccessModalContent title={SUCCESS_TITLE} message={TRANSFER_CONFIRM_SUCCESS} onClose={onClose}/>
      case 2:
        return <ErrorModalContent title={ERROR_TITLE} message={TRANSFER_CONFIRM_ERROR} onClose={onClose}/>
      default:
    }
  }

  const renderTaxStatusValue = key => getTaxStatusTypes().filter(t => t.value === key)[0]?.name;
  const renderGradTaxStatusValue = key => getGraduatedTaxStatusTypes().filter(t => t.value === key)[0]?.name;

  return page === 0 ? (
    <div className={styles['transfer-details-modal-content']}>
      <Row>
        <Col lg={12}>
          <div>
            <Row>
              <Col lg={6} className={styles['label']}>Bondholder</Col>
              <Col lg={6} className={styles['value']}>
                { transfer.title ? transfer.title : transfer.salutation }{' '}
                {`${transfer.firstName} ${transfer.middleName} ${transfer.lastName}`}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Email Address</Col>
              <Col lg={6} className={styles['value']}>{transfer.emailAddress}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Security Name</Col>
              <Col lg={6} className={styles['value']}>{transfer.securityName}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Security ID/ISIN</Col>
              <Col lg={6} className={styles['value']}>{transfer.securityId}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Order Amount (in figure)</Col>
              <Col lg={6} className={styles['value']}>{toCurrency(transfer.transferAmount)}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Order Amount (in words)</Col>
              <Col lg={6} className={styles['value']}>{numToWords()(transfer.transferAmount)}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Purchase Date</Col>
              <Col lg={6} className={styles['value']}>
                {transfer.purchaseDate ? transfer.purchaseDate : '-' }
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Tax Status</Col>
              <Col lg={6} className={styles['value']}>{renderTaxStatusValue(transfer.taxStatus)}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Graduated Tax Status</Col>
              <Col lg={6} className={styles['value']}>
                {transfer.graduatedTaxStatus ? renderGradTaxStatusValue(transfer.graduatedTaxStatus) : '-'}
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Broker Name</Col>
              <Col lg={6} className={styles['value']}>{transfer.brokerName}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Transfer Date</Col>
              <Col lg={6} className={styles['value']}>
                {renderEditableFields('transferDate',
                  <DateInput inputProps={getTextFieldProps('transferDate')}/>)}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Settlement Date</Col>
              <Col lg={6} className={styles['value']}>
                {renderEditableFields(
                  'settlementDate',
                  <DateInput inputProps={getTextFieldProps('settlementDate')}/>)}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Registry BP ID</Col>
              <Col lg={6} className={styles['value']}>
                {renderEditableFields(
                  'fromRegistryBpId',
                  <TextInput inputProps={getTextFieldProps('fromRegistryBpId')} placeholder={""} />)}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Account Number</Col>
              <Col lg={6} className={styles['value']}>
                {renderEditableFields(
                  'fromRegistryAccountNumber',
                  <TextInput inputProps={getTextFieldProps('fromRegistryAccountNumber')} placeholder={""} />)}
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>To</Col>
              <Col lg={6} className={styles['value']}>
                {renderEditableFields(
                  'toType',
                  <DropDown inputProps={getDropdownProps('toType')} values={getToTypes()} />)}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Depository BP ID</Col>
              <Col lg={6} className={styles['value']}>
                {renderEditableFields(
                  'toDepositoryBpId',
                  <TextInput inputProps={getTextFieldProps('toDepositoryBpId')} placeholder={""} />)}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Account Number</Col>
              <Col lg={6} className={styles['value']}>
                {renderEditableFields(
                  'toDepositoryAccountNumber',
                  <TextInput inputProps={getTextFieldProps('toDepositoryAccountNumber')} placeholder={""} />)}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Registry BP ID</Col>
              <Col lg={6} className={styles['value']}>
                {renderEditableFields(
                  'toRegistryBpId',
                  <TextInput inputProps={getTextFieldProps('toRegistryBpId')} placeholder={""} />)}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Account Number</Col>
              <Col lg={6} className={styles['value']}>
                {renderEditableFields(
                  'toRegistryAccountNumber',
                  <TextInput inputProps={getTextFieldProps('toRegistryAccountNumber')} placeholder={""} />)}
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Non-Stock/Non-Profit</Col>
              <Col lg={6} className={styles['value']}>{transfer.nonStockProfit}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Tax Status</Col>
              <Col lg={6} className={styles['value']}>{renderTaxStatusValue(transfer.toTaxStatus)}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Graduated Tax Status</Col>
              <Col lg={6} className={styles['value']}>
                {transfer.toGraduatedTaxStatus ? renderGradTaxStatusValue(transfer.toGraduatedTaxStatus) : '-'}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      {transfer.transferStatus === '1' || transfer.transferStatus === '5' ? (
        <>
          <Row>
            <Col>
              <div className={styles['broker-confirmation']}>
                <Row>
                  <Col lg={12}>
                    <div className={styles['header']}>
                      BROKER CONFIRMATION
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div>
                      I/We hereby confirm the currency and correctness of the information herein provided and likewise confirm that the foregoing transfer instruction is legal, valid and binding and may be fully and unconditionally relied upon by PDTC. I/We likewise confirm that I/we have paid the applicable taxes in relation to the transaction; and should the same be incorrect, I/we agree to be liable for additional taxes, duties, assessments or governmental charges with respect there to. I/We hold PDTC free and harmless from any liability, loss or damage that may arise from its execution of the foregoing instruction. I/We recognize and agree that the transfer is subject to the PDTC Registry Rules that are in force and effect.
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <input type="checkbox" onChange={onConfirm}/>
                    {' '}
                    I confirm.
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row className={styles['button-row']}>
            <Col xs={6} lg={6}>
              <div className={styles['close-button']}>
                <Button variant="secondary" onClick={() => onClose()}>
                  CLOSE
                </Button>
              </div>
            </Col>
            <Col xs={6} lg={6}>
              <div className={styles['confirm-button']}>
                <Button disabled={loading || !checkboxState} onClick={() => confirm()}>
                  {loading ? <Spinner size="sm" animation="border"/> : 'CONFIRM'}
                </Button>
              </div>
            </Col>
          </Row>
        </>
      ) : ''}
    </div>
  ) : renderConfirmResult();
}

export default TransferDetailsModalContent;
